import {useCallback} from 'react';
import {useNavigate} from 'react-router-dom';

export const useTabRedirect = (prefix: string) => {
    const navigate = useNavigate();

    return useCallback((tab: string) => {
        navigate(`${prefix}${tab}`);
    }, [prefix, navigate]);
};
